//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GridCardComponent from '@/components/work_environments/GridCardComponent';
export default {
  name: 'ProductizeModelPage',
  components: {
    GridCardComponent: GridCardComponent
  },
  data: function data() {
    return {
      cards: [{
        title_es: 'Exportar agrupación en Audiencias Digitales',
        title_en: 'Export grouping in Digital Audiences',
        subtitle_es: 'Aquí se podrá exportar al módulo de Audiencias Digitales la agrupación que ha perfilado en el sandbox.',
        subtitle_en: 'Here you can export to the Digital Audiences module the grouping that you have profiled in the sandbox.',
        flex: 4,
        color: '#F1F1F1',
        image: 'Personalizados.png',
        path: '/attributes/use_cases/productize_usecase_audiences',
        access: true
      }, {
        title_es: 'Exportar agrupación en mi organización',
        title_en: 'Export grouping in my organization',
        subtitle_es: 'Aquí se podrá exportar bases dentro de la organización',
        subtitle_en: 'Here you can export bases within the organization',
        subtitle: '',
        flex: 4,
        color: '#F1F1F1',
        image: 'Personalizados.png',
        path: '/attributes/use_cases/productize_use_case',
        access: true
      }, {
        title_es: 'Exportar agrupación de atributos transformados',
        title_en: 'Export grouping of transformed attributes',
        subtitle_es: 'Exportación de atributos transformados para la utilización de modelos análiticos',
        subtitle_en: 'Export of transformed attributes for the use of analytical models',
        subtitle: '',
        flex: 4,
        color: '#F1F1F1',
        image: 'Personalizados.png',
        path: '/attributes/use_cases/productize_transformed_attributes',
        access: true
      }]
    };
  }
};